import {Component, OnInit} from "@angular/core";
import { StatusListener }    from "../../../status-listener";
import { AppService }        from "../../../services/app.service";

@Component({
	selector: "app-warning",
	templateUrl: "./warning.component.html",
	styleUrls: ["./warning.component.scss"]
})
export class WarningComponent extends StatusListener implements OnInit {

	warningText = "";

	constructor(app: AppService) {
		super(app);
	}

	ngOnInit() {
		super.ngOnInit();
		// Translate warning text
		// Could fail because server is offline. In this case,
		// show German and English "error" text.
		let warningText = this.translate("🌐General.Warning");
		if (warningText == "General.Warning")
			warningText = "Fehler | Error";
		this.warningText = warningText;
	}

}
